<script>
  import { strings } from "../../store/store";

  export let direction1Emission,
    direction2Emission,
    direction1EmissionTonDistance,
    direction2EmissionTonDistance,
    specificEmission,
    litersPer100KmDirection1,
    litersPer100KmDirection2,
    litersPerDistanceDirection1,
    litersPerDistanceDirection2,
    eurosDirection1,
    eurosDirection2,
    centPerTonPerKmDirection1,
    centPerTonPerKmDirection2,
    centPerTonPerKm,
    centPerTon;

  const getRoundedNumber = (numberToRound, decimal) => {
    return Math.round(numberToRound * decimal) / decimal;
  };
</script>

<div class="tables">
  <h4>{$strings.transportEmissionsHeading}</h4>
  <table>
    <tr>
      <td>{$strings.direction1Text}:</td>
      <td>{getRoundedNumber(direction1Emission, 10)} kgCO2ekv</td>
    </tr>
    <tr class="no-border">
      <td>{$strings.direction2Text}:</td>
      <td>{getRoundedNumber(direction2Emission, 10)} kgCO2ekv</td>
    </tr>
    <tr class="row-with-blue-bg">
      <td>{$strings.totalEmissionsText}:</td>
      <td>
        {getRoundedNumber(direction1Emission + direction2Emission, 10)} kgCO2ekv
      </td>
    </tr>
    <tr class="row-with-green-bg">
      <td>{$strings.totalEmissionsWithRenewableFuelText}</td>
      <td>
        {getRoundedNumber((direction1Emission + direction2Emission) * 0.1, 10)} kgCO2ekv
      </td>
    </tr>
    <tr>
      <td>{$strings.direction1Text}:</td>
      <td>
        {getRoundedNumber(direction1EmissionTonDistance, 10)} gCO2ekv/ton/km
      </td>
    </tr>
    <tr class="no-border">
      <td>{$strings.direction2Text}:</td>
      <td
        >{getRoundedNumber(direction2EmissionTonDistance, 10)} gCO2ekv/ton/km</td
      >
    </tr>
    <tr class="row-with-blue-bg">
      <td> {$strings.specificEmissionText}:</td>
      <td>{getRoundedNumber(specificEmission, 10)} gCO2ekv/ton/km</td>
    </tr>
  </table>

  <h4>{$strings.fuelAndPriceHeading}:</h4>
  <table>
    <tr>
      <td> {$strings.direction1Text}: </td>
      <td class="td-flex">
        <span
          >{getRoundedNumber(litersPer100KmDirection1, 1)} litraa/100 km</span
        >
        <span
          >{getRoundedNumber(litersPerDistanceDirection1, 1)} litraa/matka</span
        >
        <span>{getRoundedNumber(eurosDirection1, 10)} euroa</span>
      </td>
    </tr>

    <tr class="no-border">
      <td> {$strings.direction2Text}: </td>
      <td class="td-flex">
        <span
          >{getRoundedNumber(litersPer100KmDirection2, 1)} litraa/100 km</span
        >
        <span>
          {getRoundedNumber(litersPerDistanceDirection2, 1)} litraa/matka
        </span>
        <span>{getRoundedNumber(eurosDirection2, 10)} euroa</span>
      </td>
    </tr>

    <tr class="row-with-blue-bg">
      <td> {$strings.totalConsumptionText}: </td>
      <td>
        {getRoundedNumber(
          litersPerDistanceDirection1 + litersPerDistanceDirection2,
          1
        )} litraa
      </td>
    </tr>
    <tr class="row-with-blue-bg">
      <td>{$strings.totalPriceText}:</td>
      <td>{getRoundedNumber(eurosDirection1 + eurosDirection2, 10)} euroa</td>
    </tr>
    <tr>
      <td>{$strings.direction1Text}:</td>
      <td>{getRoundedNumber(centPerTonPerKmDirection1, 100)} senttiä/ton/km</td>
    </tr>
    <tr>
      <td>{$strings.direction2Text}:</td>
      <td>{getRoundedNumber(centPerTonPerKmDirection2, 100)} senttiä/ton/km</td>
    </tr>
    <tr>
      <td>{$strings.totalPriceText}:</td>
      <td>{getRoundedNumber(centPerTonPerKm, 100)} senttiä/ton/km</td>
    </tr>
    <tr>
      <td>{$strings.totalPriceText}:</td>
      <td>{getRoundedNumber(centPerTon, 10)} senttiä/ton</td>
    </tr>
  </table>
</div>

<style>
  .tables {
    width: 100%;
    background-color: white;
    margin-top: 20px;
  }
  table {
    border-collapse: collapse;
    width: 100%;
  }
  tr {
    vertical-align: top;
    border-bottom: 1px solid #dcdcdc;
    background-color: white;
  }

  td {
    text-align: start;
    padding: 15px 0 15px 22px;
  }

  td:first-child {
    width: 30%;
    min-width: 140px;
    font-size: 14px;
  }

  td span:first-child {
    margin-bottom: 15px;
  }

  td span:last-child {
    margin-top: 15px;
  }

  .td-flex {
    display: flex;
    flex-direction: column;
  }
  .row-with-green-bg {
    background-color: #acf893;
    border-bottom: 1px solid #fff;
  }

  .row-with-green-bg > :first-child,
  .row-with-blue-bg > :first-child {
    font-weight: 500;
  }

  .row-with-blue-bg {
    background-color: #8fcdff;
    border-bottom: 1px solid #fff;
  }
  .no-border {
    border: none;
  }
</style>
